import React, { useMemo, useState, useCallback, useEffect } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Link, useSearchParams } from "react-router-dom";
import { useColumnOrderSave } from "../../../core/common/useColumnOrderSave";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import { useSelector } from "react-redux";
import DefaultEditor from "react-simple-wysiwyg";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { TagsInput } from "react-tag-input-component";
import CountUp from "react-countup";
import {
  initialSettings,
  project,
  salestypelist,
  socialMedia,
  tagInputValues,
} from "../../../core/common/selectoption/selectoption";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import {
  deleteDeal,
  exportDeals,
  fetchDealById,
  fetchDealsByUserId,
  updateDeal,
  Deal,
  deleteDealsBulk,
} from "../../../api/deal";
import { DealSource, fetchAllDealSourcesActive } from "../../../api/dealsource";
import {
  exportDealsExcel,
  exportDealsPDF,
  exportSelectedDealsExcel,
  exportSelectedDealsPDF,
} from "../../../api/dealexport";
import { Avatar, Dropdown, Menu, Button, Descriptions, Checkbox } from "antd";
import { DownOutlined, FunnelPlotFilled } from "@ant-design/icons";
import { highlightMatch } from "../../../core/common/highlightmatch";
import { RootState } from "../../../core/data/redux/store";
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
import {
  validateDealEditForm,
  DealEditErrors,
  formatDealValue,
} from "../../../api/mainValidation";
import { array } from "yup";
import AnimatedBadge from "../../../core/common/AnimatedBadge";
import SequentialHighlight from "../../../core/common/SequentialHighlight";
import ColumnManagement from "../../../core/common/ColumnManagement";
import ScrollToTop from "../../../core/common/ScrollToTop";
import ModalDeleteEffect from "../../../core/common/ModalDeleteEffect";
import SubmoduleHoverCard from "../../../core/common/SubCard2Button";
import TextCopy2 from "../../../core/common/textcopy2";
import DealDetailsModal from "../../../core/common/DealDetailsModal";

type Filters = {
  leadName: string;
  contact: string;
  owner: string[];
  status: string[];
  priority: string[];
  dealSources?: string[];
  products?: string[];
};

const defaultVisibleColumns = {
  deal_name: true,
  owner: true,
  deal_value: true,
  currency: true,
  contact: true,
  product: true,
  expected_close_date: true,
  follow_up_date: true,
  due_date: true,
  deal_source: true,
  status: true,
  created_at: true,
  updated_at: true,
  priority: true,
  description: true,
  action: true,
};

const defaultColumnOrder = [
  "deal_name",
  "owner",
  "deal_value",
  "currency",
  "contact",
  "product",
  "expected_close_date",
  "follow_up_date",
  "due_date",
  "deal_source",
  "status",
  "created_at",
  "updated_at",
  "priority",
  "description",
  "action",
];

const columnLabels = {
  deal_name: "Deal Name",
  owner: "Owner",
  deal_value: "Deal Value",
  currency: "Currency",
  contact: "Contact",
  product: "Product",
  expected_close_date: "Expected Close Date",
  follow_up_date: "Follow Up Date",
  due_date: "Due Date",
  deal_source: "Deal Source",
  status: "Status",
  created_at: "Created At",
  updated_at: "Updated At",
  priority: "Priority",
  description: "Description",
  action: "Action",
};

const setupDraggable = (modalElement: HTMLElement) => {
  if (modalElement.hasAttribute("data-draggable-setup")) return;
  modalElement.setAttribute("data-draggable-setup", "true");

  const modalDialog = modalElement.classList.contains("modal-dialog")
    ? modalElement
    : (modalElement.querySelector(".modal-dialog") as HTMLElement);
  const modalHeader = modalElement.querySelector(
    ".modal-header"
  ) as HTMLElement;

  if (!modalDialog || !modalHeader) return;

  let isDragging = false;
  let offsetX = 0;
  let offsetY = 0;

  const onMouseDown = (e: MouseEvent) => {
    if ((e.target as HTMLElement).closest("button,input,select,.btn-close"))
      return;

    isDragging = true;
    const rect = modalDialog.getBoundingClientRect();
    offsetX = e.clientX - rect.left;
    offsetY = e.clientY - rect.top;

    modalDialog.classList.remove("modal-dialog-centered");
    modalDialog.style.position = "fixed";
  };

  const onMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;

    modalDialog.style.left = `${e.clientX - offsetX}px`;
    modalDialog.style.top = `${e.clientY - offsetY}px`;
  };

  const onMouseUp = () => (isDragging = false);

  modalHeader.style.cursor = "move";
  modalHeader.addEventListener("mousedown", onMouseDown);
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);
};

const Deals = () => {
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [sortKey, setSortKey] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<"Ascending" | "Descending" | null>(
    null
  );
  const [dateRange, setDateRange] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: null,
    endDate: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDeals, setSelectedDeals] = useState<string[]>([]);
  const [filters, setFilters] = useState<Filters>({
    leadName: "",
    contact: "",
    owner: [],
    status: [],
    priority: [],
    dealSources: [],
    products: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const route = all_routes;
  const [activeRangeLabel, setActiveRangeLabel] =
    useState<string>("Last 30 Days");
  const [showEditDeals, setShowEditDeals] = useState(false);
  const [filterLeadNames, setFilterLeadNames] = useState<string[]>([]);
  const [filterContacts, setFilterContacts] = useState<string[]>([]);
  const [filterOwners, setFilterOwners] = useState<string[]>([]);
  const [filterStatuses, setFilterStatuses] = useState<string[]>([]);
  const [filterPriorities, setFilterPriorities] = useState<string[]>([]);
  const [filterDealSources, setFilterDealSources] = useState<string[]>([]);
  const [filterProducts, setFilterProducts] = useState<string[]>([]);
  const [filterLeadNamesSearch, setFilterLeadNamesSearch] = useState("");
  const [filterContactsSearch, setFilterContactsSearch] = useState("");
  const [filterOwnersSearch, setFilterOwnersSearch] = useState("");
  const [filterStatusesSearch, setFilterStatusesSearch] = useState("");
  const [filterPrioritiesSearch, setFilterPrioritiesSearch] = useState("");
  const [filterDealSourcesSearch, setFilterDealSourcesSearch] = useState("");
  const [filterProductsSearch, setFilterProductsSearch] = useState("");
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const [alphaFilter, setAlphaFilter] = useState<string>("All");
  const [alphaFilterleadowner, setAlphaFilterleadowner] =
    useState<string>("All");
  const [alphaFilterproduct, setAlphaFilterproduct] = useState<string>("All");
  const [alphaFilterdealsource, setAlphaFilterdealsource] =
    useState<string>("All");
  const [alphaFiltercontact, setAlphaFiltercontact] = useState<string>("All");
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [editErrors, setEditErrors] = useState<DealEditErrors>({});

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = useCallback((date: Date | null) => {
    setSelectedDate(date);
  }, []);

  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = useCallback((date: Date | null) => {
    setSelectedDate1(date);
  }, []);

  const [selectedDate2, setSelectedDate2] = useState<Date | null>(new Date());
  const handleDateChange2 = useCallback((date: Date | null) => {
    setSelectedDate2(date);
  }, []);

  const [stars, setStars] = useState<{ [key: string]: boolean }>({});

  const initializeStarsState = useCallback((deals: Deal[]) => {
    const starsState: { [key: string]: boolean } = {};
    deals.forEach((deal) => {
      if (!starsState[deal.deal_id]) {
        starsState[deal.deal_id] = false;
      }
    });
    setStars((prev) => ({ ...prev, ...starsState }));
  }, []);

  const [dealsData, setDealsData] = useState<Deal[]>([]);
  const [orderedData, setOrderedData] = useState<Deal[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedDealId, setSelectedDealId] = useState<string | null>(null);
  const userId = useSelector((state: RootState) => state.auth.user_id);
  const userRole = useSelector((state: RootState) => state.auth.role);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showViewDetailsModal, setShowViewDetailsModal] = useState(false);
  const [selectedDealForView, setSelectedDealForView] = useState<Deal | null>(null);
  const [searchParams] = useSearchParams();
  const dealId = searchParams.get("deal_id");
  const ownerParam = searchParams.get("owner");
  useEffect(() => {
    const dealsourceParam = searchParams.get("dealsource");
    const ownersParam = searchParams.get("owners");
    if (dealsourceParam) {
      const dealsourceName = decodeURIComponent(dealsourceParam);
      setFilterDealSources([dealsourceName]);
    }
    if (ownersParam) {
      const ownerName = decodeURIComponent(ownersParam);
      setFilterOwners([ownerName]);
    }
  }, [searchParams]);

 const fetchDeals = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const data = await fetchDealsByUserId(userId);
      setDealsData(data);
      setOrderedData(data);
      initializeStarsState(data);
    } catch (error) {
      console.error("Error fetching user deals", error);
    } finally {
      setLoading(false);
    }
  }, [userId, initializeStarsState]);

  useEffect(() => {
    const getDeals = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        let data: Deal[];
        if (dealId) {
          const singleDeal = await fetchDealById(dealId);
          data = [singleDeal];
        } else {
          data = await fetchDealsByUserId(userId);
        }
        setDealsData(data);
        initializeStarsState(data);

        if (ownerParam) {
          const ownerName = decodeURIComponent(ownerParam);
          setFilters((prev) => ({ ...prev, owner: [ownerName] }));
        }
      } catch (error) {
        console.error("Error fetching deals", error);
      } finally {
        setLoading(false);
      }
    };
    getDeals();
  }, [userId, dealId, ownerParam, initializeStarsState]);

  useEffect(() => {
    const getSources = async () => {
      //try {
      const sources = await fetchAllDealSourcesActive();
      setDealSources(sources);
      //} catch (err) {
      //console.error("Failed to fetch deal sources");
      //}
    };
    getSources();
  }, []);

  useEffect(() => {
    const makeModalDraggable = (modalId: string) => {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;

      const modalDialog = modalElement.querySelector(
        ".modal-dialog"
      ) as HTMLElement;
      const modalHeader = modalElement.querySelector(
        ".modal-header"
      ) as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let currentX = 0;
      let currentY = 0;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      // Reset position when modal is shown
      const resetPosition = () => {
        // Reset all position variables
        currentX = 0;
        currentY = 0;
        initialX = 0;
        initialY = 0;
        startX = 0;
        startY = 0;
        isDragging = false;

        // Remove only the inline styles that were added during dragging
        modalDialog.style.position = "";
        modalDialog.style.top = "";
        modalDialog.style.left = "";
        modalDialog.style.transform = "";
        modalDialog.style.margin = "";
        modalDialog.style.transition = "";
        modalDialog.style.width = "";
        modalDialog.style.maxWidth = "";

        // Restore centered class if it was removed
        if (!modalDialog.classList.contains("modal-dialog-centered")) {
          modalDialog.classList.add("modal-dialog-centered");
        }
      };

      // Listen for modal show event - reset when modal is about to show
      const handleShow = () => {
        // Reset immediately when modal starts showing
        resetPosition();
      };

      // Listen for modal shown event - ensure reset after modal is fully displayed
      const handleShown = () => {
        // Double-check reset after modal is fully shown
        resetPosition();
      };

      // Listen for modal hidden event - reset when modal is fully hidden
      const handleHidden = () => {
        resetPosition();
      };

      modalElement.addEventListener("show.bs.modal", handleShow);
      modalElement.addEventListener("shown.bs.modal", handleShown);
      modalElement.addEventListener("hidden.bs.modal", handleHidden);

      const dragStart = (e: MouseEvent) => {
        // Only allow dragging from header, not from close button or other interactive elements
        const target = e.target as HTMLElement;
        if (
          target.closest(".btn-close") ||
          target.closest("button") ||
          target.closest("input") ||
          target.closest("select")
        ) {
          return;
        }

        if (
          e.target === modalHeader ||
          modalHeader.contains(e.target as Node)
        ) {
          isDragging = true;
          modalHeader.style.cursor = "move";

          // Get current position and size of modal dialog
          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          // Get computed styles to preserve the modal's size
          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          // Remove centered class to allow free movement
          modalDialog.classList.remove("modal-dialog-centered");

          // Set initial position based on current position
          modalDialog.style.position = "fixed";
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = "0";
          modalDialog.style.transform = "none";
          modalDialog.style.transition = "none";

          // Preserve the modal's width and max-width to prevent size change
          if (
            currentWidth &&
            currentWidth !== "auto" &&
            currentWidth !== "0px"
          ) {
            modalDialog.style.width = currentWidth;
          }
          if (
            currentMaxWidth &&
            currentMaxWidth !== "none" &&
            currentMaxWidth !== "0px"
          ) {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (
            currentMinWidth &&
            currentMinWidth !== "0px" &&
            currentMinWidth !== "auto"
          ) {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;

        e.preventDefault();

        // Calculate new position
        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        // Get modal dialog dimensions
        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        // Constrain to viewport
        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        // Update position
        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;

        // Store current position for next drag
        currentX = constrainedX;
        currentY = constrainedY;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = "move";
          modalDialog.style.transition = "";
          // Keep the fixed positioning during drag, but allow reset on next open
        }
      };

      // Add cursor style to header
      modalHeader.style.cursor = "move";
      modalHeader.style.userSelect = "none";

      // Event listeners
      modalHeader.addEventListener("mousedown", dragStart);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", dragEnd);

      // Cleanup function
      return () => {
        modalElement.removeEventListener("show.bs.modal", handleShow);
        modalElement.removeEventListener("shown.bs.modal", handleShown);
        modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        modalHeader.removeEventListener("mousedown", dragStart);
        document.removeEventListener("mousemove", drag);
        document.removeEventListener("mouseup", dragEnd);
      };
    };

    const cleanup = makeModalDraggable("delete_deal");

    return () => {
      cleanup?.();
    };
  }, []);

  useEffect(() => {
    const setupModalDraggable = (modalElement: HTMLElement) => {
      if (modalElement.hasAttribute("data-draggable-setup")) return;
      modalElement.setAttribute("data-draggable-setup", "true");

      const modalDialog = modalElement.querySelector(
        ".modal-dialog"
      ) as HTMLElement;
      const modalHeader = modalElement.querySelector(
        ".modal-header"
      ) as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      const resetPosition = () => {
        isDragging = false;
        modalDialog.style.position = "";
        modalDialog.style.top = "";
        modalDialog.style.left = "";
        modalDialog.style.transform = "";
        modalDialog.style.margin = "";
        modalDialog.style.transition = "";
        modalDialog.style.width = "";
        modalDialog.style.maxWidth = "";

        if (!modalDialog.classList.contains("modal-dialog-centered")) {
          modalDialog.classList.add("modal-dialog-centered");
        }
      };

      const dragStart = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (
          target.closest(".btn-close") ||
          target.closest("button") ||
          target.closest("input") ||
          target.closest("select")
        ) {
          return;
        }

        if (
          e.target === modalHeader ||
          modalHeader.contains(e.target as Node)
        ) {
          isDragging = true;
          modalHeader.style.cursor = "move";

          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          modalDialog.classList.remove("modal-dialog-centered");

          modalDialog.style.position = "fixed";
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = "0";
          modalDialog.style.transform = "none";
          modalDialog.style.transition = "none";

          if (
            currentWidth &&
            currentWidth !== "auto" &&
            currentWidth !== "0px"
          ) {
            modalDialog.style.width = currentWidth;
          }
          if (
            currentMaxWidth &&
            currentMaxWidth !== "none" &&
            currentMaxWidth !== "0px"
          ) {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (
            currentMinWidth &&
            currentMinWidth !== "0px" &&
            currentMinWidth !== "auto"
          ) {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;
        e.preventDefault();

        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = "move";
          modalDialog.style.transition = "";
        }
      };

      modalHeader.style.cursor = "move";
      modalHeader.style.userSelect = "none";

      modalHeader.addEventListener("mousedown", dragStart);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", dragEnd);

      const handleHidden = () => {
        resetPosition();
        modalElement.removeAttribute("data-draggable-setup");
      };

      modalElement.addEventListener("hidden.bs.modal", handleHidden);
    };

    const checkAndSetup = () => {
      const modals = document.querySelectorAll(".modal.show");
      modals.forEach((modal) => {
        const modalEl = modal as HTMLElement;
        const h4 = modalEl.querySelector("h4")?.textContent || "";

        if (
          h4.includes("Confirm Bulk Delete") &&
          !modalEl.hasAttribute("data-draggable-setup")
        ) {
          setTimeout(() => setupModalDraggable(modalEl), 50);
        }
      });
    };

    const interval = setInterval(checkAndSetup, 100);

    return () => {
      clearInterval(interval);
    };
  }, [showBulkDeleteModal]);

  const handleDeleteDeal = useCallback(async () => {
    if (!selectedDealId) return;
    try {
      setLoading(true);
      await deleteDeal(selectedDealId);
      setDealsData((prev) =>
        prev.filter((deal) => deal.deal_id !== selectedDealId)
      );
      setSelectedDealId(null);
      //toast.success("Deal deleted successfully");
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }, [selectedDealId]);

  const [editData, setEditData] = useState<Deal | null>(null);
  const [dealSources, setDealSources] = useState<DealSource[]>([]);

  const handleBulkDelete = async () => {
    if (selectedDeals.length === 0) return;

    setIsDeleting(true); // Start loading

    try {
      await deleteDealsBulk(selectedDeals);
      toast.success("Selected deals deleted successfully");

      // Refresh data
      await fetchDeals(); // or however you refresh your deals list

      setSelectedDeals([]); // Clear selection
    } catch (err) {
      console.error("Bulk delete error:", err);
      toast.error("Failed to delete selected deals");
    } finally {
      setIsDeleting(false); // Always stop loading
      setShowBulkDeleteModal(false); // Close modal after operation
    }
  };

  const handleEditClick = useCallback(async (dealId: string) => {
    try {
      const deal = await fetchDealById(dealId);
      setEditData(deal);
      setShowEditDeals(true);
    } catch (err) {
      console.error("Failed to load deal for editing");
    }
  }, []);

  const handleSaveEdit = useCallback(async () => {
    if (!editData) return;

    const validationPayload = {
      deal_value: editData?.deal_value || "",
      expected_closing_date: editData?.expected_closing_date || "",
      follow_up_date: editData?.follow_up_date || "",
      due_date: editData?.due_date || "",
      deal_source_id: editData?.dealsource?.deal_source_id || "",
      status: editData?.status || "",
      deal_priority: editData?.deal_priority || "",
      Description: editData?.Description || "",
    };

    // Run validation
    const errors = validateDealEditForm(validationPayload);

    // If any errors exist → stop & display
    if (Object.keys(errors).length > 0) {
      setEditErrors(errors);
      toast.error("Please fix the highlighted errors");
      return;
    }
    //try {
    await updateDeal(editData.deal_id, {
      company_name: editData.contact?.company_name,
      deal_value: editData.deal_value,
      currency: editData.currency,
      expected_closing_date: editData.expected_closing_date,
      follow_up_date: editData.follow_up_date,
      due_date: editData.due_date,
      deal_source_id: editData.dealsource?.deal_source_id,
      status: editData.status,
      deal_priority: editData.deal_priority,
      Description: editData.Description,
    });
      toast.success("Deal updated successfully");
      // Local state update for performance
    setDealsData((prev) =>
      prev.map((d) =>
        d.deal_id === editData.deal_id ? { ...d, ...editData } : d
      )
    );
    //toast.success("Deal updated successfully");
    await fetchDeals();
    setEditErrors({});
    setShowEditDeals(false);
    // } catch (err) {
    //   console.error("Failed to update deal");
    // }
  }, [editData]);

  const getNestedValue = useCallback((obj: any, path: string) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  }, []);

  const [activeDealStatusTab, setActiveDealStatusTab] = useState<string | null>(
    null
  );

  const dealStatusTabs = useMemo(
    () => [
      { key: "won", label: "Won" },
      { key: "lost", label: "Lost" },
      { key: "open", label: "Open" },
      { key: "Closed", label: "Closed" },
    ],
    []
  );

  const dealStatusCounts = useMemo(() => {
    const counts: Record<string, number> = {
      all: dealsData.length,
      won: 0,
      lost: 0,
      open: 0,
      Closed: 0,
    };
    dealsData.forEach((deal) => {
      const status = deal.status;
      if (status && counts[status] !== undefined) {
        counts[status]++;
      }
    });
    return counts;
  }, [dealsData]);

  const processedDeals = useMemo(() => {
    const { startDate, endDate } = dateRange;
    let filtered = [...dealsData];

    // Deal ID filter (if viewing specific deal)
    if (dealId) {
      filtered = filtered.filter((deal) => deal.deal_id === dealId);
    }
    

    // Date range filter
    if (startDate && endDate) {
      filtered = filtered.filter((deal) => {
        const dealDate = new Date(deal.created_at);
        return dealDate >= new Date(startDate) && dealDate <= new Date(endDate);
      });
    }

    if (alphaFilter && alphaFilter !== "All") {
      filtered = filtered.filter((deal) => {
        const name = deal.contact?.company_name || "";
        return name.toLowerCase().startsWith(alphaFilter.toLowerCase());
      });
    }
    if (alphaFilterleadowner && alphaFilterleadowner !== "All") {
      filtered = filtered.filter((deal) => {
        const name = deal.leads?.users?.name || "";
        return name
          .toLowerCase()
          .startsWith(alphaFilterleadowner.toLowerCase());
      });
    }
    if (alphaFilterdealsource && alphaFilterdealsource !== "All") {
      filtered = filtered.filter((deal) => {
        const name = deal.dealsource?.deal_source_nema || "";
        return name
          .toLowerCase()
          .startsWith(alphaFilterdealsource.toLowerCase());
      });
    }
    if (alphaFilterproduct && alphaFilterproduct !== "All") {
      filtered = filtered.filter((deal) => {
        const name = deal.product?.product_name || "";
        return name.toLowerCase().startsWith(alphaFilterproduct.toLowerCase());
      });
    }
    if (alphaFiltercontact && alphaFiltercontact !== "All") {
      filtered = filtered.filter((deal) => {
        const name = deal.contact?.contact_person_name || "";
        return name.toLowerCase().startsWith(alphaFiltercontact.toLowerCase());
      });
    }

    // Lead name filter
    if (filterLeadNames.length > 0) {
      filtered = filtered.filter((deal) =>
        filterLeadNames.some((f) =>
          deal.contact?.company_name?.toLowerCase().includes(f.toLowerCase())
        )
      );
    }
    if (filterContacts.length > 0) {
      filtered = filtered.filter((deal) =>
        filterContacts.some((f) =>
          deal.contact?.contact_person_name
            ?.toLowerCase()
            .includes(f.toLowerCase())
        )
      );
    }
    if (filterOwners.length > 0) {
      filtered = filtered.filter((deal) =>
        filterOwners.some((f) =>
          (deal.leads?.users?.name || "")
            .toLowerCase()
            .includes(f.toLowerCase())
        )
      );
    }
    if (filterStatuses.length > 0 || activeDealStatusTab !== null) {
      filtered = filtered.filter((deal) => {
        const status = (deal.status || "").toLowerCase();
        const matchesFilter =
          filterStatuses.length === 0 ||
          filterStatuses.some((f) => status.includes(f.toLowerCase()));
        const matchesTab =
          !activeDealStatusTab || status === activeDealStatusTab.toLowerCase();
        return matchesFilter && matchesTab;
      });
    }
    if (filterPriorities.length > 0) {
      filtered = filtered.filter((deal) =>
        filterPriorities.some((f) =>
          (deal.deal_priority || "").toLowerCase().includes(f.toLowerCase())
        )
      );
    }
    if (filterDealSources.length > 0) {
      filtered = filtered.filter((deal) =>
        filterDealSources.some((f) =>
          (deal.dealsource?.deal_source_nema || "")
            .toLowerCase()
            .includes(f.toLowerCase())
        )
      );
    }
    if (filterProducts.length > 0) {
      filtered = filtered.filter((deal) =>
        filterProducts.some((f) =>
          (deal.product?.product_name || "")
            .toLowerCase()
            .includes(f.toLowerCase())
        )
      );
    }
    // Search filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (deal) =>
          deal.contact?.company_name?.toLowerCase().includes(term) ||
          deal.contact?.contact_person_name?.toLowerCase().includes(term) ||
          deal.leads?.users?.name?.toLowerCase().includes(term) ||
          deal.status?.toLowerCase().includes(term) ||
          deal.deal_priority?.toLowerCase().includes(term) ||
          deal.dealsource?.deal_source_nema?.toLowerCase().includes(term) ||
          deal.product?.product_name?.toLowerCase().includes(term) ||
          deal.currency?.toLowerCase().includes(term) ||
          deal.deal_value?.toLowerCase().includes(term) ||
          deal.Description?.toLowerCase().includes(term)
      );
    }

    // Sorting
    if (!sortKey || !sortOrder) return filtered;

    return [...filtered].sort((a, b) => {
      const aValue = getNestedValue(a, sortKey);
      const bValue = getNestedValue(b, sortKey);
      if (aValue === bValue) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;

      return sortOrder === "Ascending"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }, [
    dateRange,
    dealsData,
    activeDealStatusTab,
    searchTerm,
    sortKey,
    sortOrder,
    getNestedValue,
    filterLeadNames,
    filterContacts,
    filterOwners,
    filterStatuses,
    filterPriorities,
    filterDealSources,
    filterProducts,
    alphaFilter,
    alphaFilterleadowner,
    alphaFilterdealsource,
    alphaFilterproduct,
    alphaFiltercontact,
  ]);

  const renderFilterDropdown = ({
    label,
    filterState,
    setFilterState,
    items,
    counts,
  }: {
    label: string;
    filterState: string[];
    setFilterState: React.Dispatch<React.SetStateAction<string[]>>;
    items: { key: string; label: string; icon?: JSX.Element }[]; // removed icon
    counts: Record<string, number>;
  }) => {
    const activeCount =
      filterState.length === 1 ? counts[filterState[0]] ?? 0 : null;

    return (
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ height: 26, whiteSpace: "nowrap" }}
        onClick={(e) => e.stopPropagation()}
      >
        <span className="me-2">{label}</span>

        {/* Main Filter Dropdown with Checkboxes + Counts */}
        <Dropdown
          trigger={["click"]}
          overlay={
            <Menu
              selectedKeys={filterState}
              multiple
              style={{ width: 260, maxHeight: 320, overflowY: "auto" }}
              onClick={(e) => e.domEvent.stopPropagation()}
            >
              {/* All Option */}
              <Menu.Item
                key="all"
                onClick={() => setFilterState([])}
                className="d-flex justify-content-between align-items-center"
              >
                <Checkbox checked={filterState.length === 0}>
                  All {label}s
                </Checkbox>
                <span className="text-muted small ms-3">
                  ({(counts.all ?? 0).toLocaleString()})
                </span>
              </Menu.Item>

              <Menu.Divider />

              {/* Dynamic Items */}
              {items.map(({ key, label: itemLabel }) => {
                const isChecked = filterState.includes(key);
                const count = counts[key] ?? 0;

                return (
                  <Menu.Item
                    key={key}
                    onClick={() =>
                      setFilterState((prev) =>
                        isChecked
                          ? prev.filter((v) => v !== key)
                          : [...prev, key]
                      )
                    }
                    className="d-flex justify-content-between align-items-center"
                  >
                    <Checkbox checked={isChecked}>{itemLabel}</Checkbox>
                    <span className="text-muted small ms-3">
                      ({count.toLocaleString()})
                    </span>
                  </Menu.Item>
                );
              })}
            </Menu>
          }
        >
          <Button
            size="small"
            type="text"
            onClick={(e) => e.stopPropagation()}
            className="me-1"
          >
            <FunnelPlotFilled
              style={{
                fontSize: 15,
                color: filterState.length > 0 ? "#1890ff" : "#666",
              }}
            />
            {activeCount !== null && (
              <span className="ms-1 small fw-semibold ">
                {activeCount.toLocaleString()}
              </span>
            )}
          </Button>
        </Dropdown>

        {/* Keep your existing A-Z Alphabetical Filter unchanged */}
        <Dropdown
          trigger={["click"]}
          onOpenChange={(open) =>
            open && setTimeout(() => document.body.click(), 0)
          }
          overlay={
            <Menu
              selectedKeys={
                alphaFilterleadowner ? [alphaFilterleadowner] : ["All"]
              }
              onClick={({ key }) =>
                setAlphaFilterleadowner(key === "All" ? "" : key)
              }
              style={{ width: 50, maxHeight: 250, overflow: "auto" }}
            >
              <Menu.Item key="All" className="text-center">
                All
              </Menu.Item>
              {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                <Menu.Item key={letter} className="text-center">
                  {letter}
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <Button
            size="small"
            type="text"
            onClick={(e) => e.stopPropagation()}
            style={{
              fontSize: 12,
              height: 17,
              padding: "0 8px",
              border: "1px solid #d9d9d9",
              background: "#fafafa",
            }}
          >
            {alphaFilterleadowner ? alphaFilterleadowner.toUpperCase() : "ALL"}
            <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
          </Button>
        </Dropdown>
      </div>
    );
  };

  const priorityCounts = useMemo(() => {
    const counts: Record<string, number> = {
      all: dealsData.length,
      high: 0,
      medium: 0,
      low: 0,
    };

    dealsData.forEach((deal) => {
      const priority = deal.deal_priority?.toLowerCase() || "unknown";
      if (counts[priority] !== undefined) {
        counts[priority]++;
      }
    });

    return counts;
  }, [dealsData]);

  // Owner Counts
  const ownerCounts = useMemo(() => {
    const counts: Record<string, number> = { all: dealsData.length };
    dealsData.forEach((deal) => {
      const owner = deal.leads?.users?.name || "Unassigned";
      counts[owner] = (counts[owner] || 0) + 1;
    });
    return counts;
  }, [dealsData]);

  // Product Counts
  const productCounts = useMemo(() => {
    const counts: Record<string, number> = { all: dealsData.length };
    dealsData.forEach((deal) => {
      const product = deal.product?.product_name || "Unknown";
      counts[product] = (counts[product] || 0) + 1;
    });
    return counts;
  }, [dealsData]);

  // Deal Source Counts
  const dealSourceCounts = useMemo(() => {
    const counts: Record<string, number> = { all: dealsData.length };
    dealsData.forEach((deal) => {
      const source = deal.dealsource?.deal_source_nema || "Unknown";
      counts[source] = (counts[source] || 0) + 1;
    });
    return counts;
  }, [dealsData]);

  const resetFilters = () => {
    setFilterLeadNames([]);
    setFilterContacts([]);
    setFilterOwners([]);
    setFilterStatuses([]);
    setFilterPriorities([]);
    setFilterDealSources([]);
    setFilterProducts([]);
    setFilterLeadNamesSearch("");
    setFilterContactsSearch("");
    setFilterOwnersSearch("");
    setFilterStatusesSearch("");
    setFilterPrioritiesSearch("");
    setFilterDealSourcesSearch("");
    setFilterProductsSearch("");
    setOpenAccordion(null);
    setActiveDealStatusTab(null); // If you want to reset tabs too
    setDateRange({ startDate: null, endDate: null });
    setActiveRangeLabel("Last 30 Days");
    setSearchTerm("");
    setSortKey(null);
    setSortOrder(null);
  };
  const uniqueOwners = useMemo(() => {
    return Array.from(
      new Set(dealsData.map((deal) => deal.leads?.users?.name).filter(Boolean))
    );
  }, [dealsData]);

  // const defaultColumnConfig = useMemo(
  //   () => [
  //     { key: "SI_no", label: "S.No", visible: true },
  //     { key: "dealName", label: "Deal Name", visible: true },
  //     { key: "owner", label: "Owner", visible: true },
  //     { key: "dealValue", label: "Deal Value", visible: true },
  //     { key: "currency", label: "Currency", visible: true },
  //     { key: "contact", label: "Contact", visible: true },
  //     { key: "product", label: "Product", visible: true },
  //     { key: "expectedCloseDate", label: "Expected Close Date", visible: true },
  //     { key: "followUpDate", label: "Follow Up Date", visible: true },
  //     { key: "dueDate", label: "Due Date", visible: true },
  //     { key: "dealSource", label: "Deal Source", visible: true },
  //     { key: "status", label: "Status", visible: true },
  //     { key: "createdAt", label: "Created At", visible: true },
  //     { key: "updatedAt", label: "Updated At", visible: true },
  //     { key: "priority", label: "Priority", visible: true },
  //     { key: "description", label: "Description", visible: true },
  //     { key: "actions", label: "Actions", visible: true },
  //   ],
  //   []
  // );

  // const [columnConfig, setColumnConfig] = useState(defaultColumnConfig);

  // Default order for non-sticky columns
  // const defaultColumnOrder = [
  //   "owner",
  //   "dealValue",
  //   "currency",
  //   "contact",
  //   "product",
  //   "expectedCloseDate",
  //   "followUpDate",
  //   "dueDate",
  //   "dealSource",
  //   "status",
  //   "createdAt",
  //   "updatedAt",
  //   "priority",
  //   "description",
  // ];

  const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
    defaultVisibleColumns
  );
  // Column order state for drag and drop (only non-sticky columns)
  const [columnKeys, setColumnKeys] = useState<string[]>(() => {
    const saved = localStorage.getItem("dealsColumnKeys");
    if (saved) {
      const parsed = JSON.parse(saved);
      const keyMap: Record<string, string> = {
        dealName: "deal_name",
        dealValue: "deal_value",
        expectedCloseDate: "expected_close_date",
        followUpDate: "follow_up_date",
        dueDate: "due_date",
        dealSource: "deal_source",
        createdAt: "created_at",
        updatedAt: "updated_at",
        actions: "action",
      };
      return parsed.map((k: string) => keyMap[k] || k);
    }
    return defaultColumnOrder;
  });

  // Hook for save prompt on navigation/refresh
  const { SaveModal } = useColumnOrderSave({
    columnKeys,
    localStorageKey: "dealsColumnKeys",
    defaultOrder: defaultColumnOrder,
  });

  const handleColumnToggle = useCallback((key: string) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  }, []);


  const columns = useMemo(() => {
    const allColumnsMap: Record<string, any> = {
      index: {
        title: "S.No",
        key: "index",
        dataIndex: "SI_no",
        fixed: "left",
        render: (_text: any, _record: any, index: number) =>
          (currentPage - 1) * pageSize + index + 1,
      },
      deal_name: {
        title: (
          <div
            className="flex items-center justify-between"
            style={{ height: 22, whiteSpace: "nowrap" }}
            onClick={(e) => e.stopPropagation()}
          >
            <span className="me-2">Deal Name</span>

            <Dropdown
              trigger={["click"]}
              onOpenChange={(open) =>
                open && setTimeout(() => document.body.click(), 0)
              }
              overlay={
                <Menu
                  selectedKeys={alphaFilter ? [alphaFilter] : ["All"]}
                  onClick={({ key }) =>
                    setAlphaFilter(key === "All" ? "" : key)
                  }
                  style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                >
                  <Menu.Item key="All" className="text-center">
                    All
                  </Menu.Item>
                  {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                    <Menu.Item key={letter} className="text-center">
                      {letter}
                    </Menu.Item>
                  ))}
                </Menu>
              }
            >
              <Button
                size="small"
                type="text"
                onClick={(e) => e.stopPropagation()}
                style={{
                  fontSize: 12,
                  height: 17,
                  padding: "0 8px",
                  border: "1px solid #d9d9d9",
                  background: "#fafafa",
                }}
              >
                {alphaFilter ? alphaFilter.toUpperCase() : "ALL"}
                <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
              </Button>
            </Dropdown>
          </div>
        ),
        dataIndex: "contact.company_name",
        key: "deal_name",
        fixed: "left",
        render: (_: any, record: Deal) => {
          const companyName = record.contact?.company_name || "N/A";
          const contactName = record.contact?.contact_person_name || "N/A";
          const initial = companyName.charAt(0).toUpperCase();
          return (
            <div className="d-flex align-items-center gap-2">
              <Avatar
                shape="square"
                className="btn btn-primary"
                style={{
                  width: 36,
                  height: 36,
                  fontSize: 16,
                  fontWeight: 600,
                }}
                onClick={() => handleEditClick(record.deal_id)}
              >
                {initial}
              </Avatar>
              <div className="d-flex flex-column">
                <strong className="fw-semibold text-dark">
                  {highlightMatch(companyName, searchTerm)}
                </strong>
                <span className="text-muted">
                  {highlightMatch(contactName, searchTerm)}
                </span>
              </div>
           </div>
          );
        },
      },
      owner: {
        title: renderFilterDropdown({
          label: "Owner",
          filterState: filterOwners,
          setFilterState: setFilterOwners,
          items: Array.from(
            new Set(dealsData.map((d) => d.leads?.users?.name).filter(Boolean))
          )
            .sort()
            .map((name) => ({
              key: name,
              label: name,
              icon: <></>, // No icon needed for dynamic items
            })),
          counts: ownerCounts,
        }),
        dataIndex: "leads.users.name",
        render: (_: any, record: any) => (
          <SubmoduleHoverCard
            name={highlightMatch(record.leads?.users?.name || "N/A", searchTerm)}
            role="Deals"
            contactleadowner_name={record.leads?.users?.name}
            leadowner_name={record.leads?.users?.name}
            quoteowner_name={record.leads?.users?.name}
            createdAt={record.created_at}
            variant2={["contactleadOwner", "leadOwner", "quoteOwner"]}
          />
        ),
      },
      deal_value: {
        title: "Deal Value",
        dataIndex: "deal_value",
        key: "deal_value",
        render: (text: any) => highlightMatch(text || "N/A", searchTerm),
      },
      currency: {
        title: "Currency",
        dataIndex: "currency",
        render: (text: any) => highlightMatch(text || "N/A", searchTerm),
      },
      contact: {
        title: (
          <div
            className="flex items-center justify-between"
            style={{ height: 22, whiteSpace: "nowrap" }}
            onClick={(e) => e.stopPropagation()} // ← prevents header sort/expand
          >
            <span className="me-2">Contact</span>

            {/* Ant Design Dropdown – pure, tiny, beautiful */}
            <Dropdown
              trigger={["click"]}
              onOpenChange={(open) =>
                open && setTimeout(() => document.body.click(), 0)
              } // optional: close on outside click
              overlay={
                <Menu
                  selectedKeys={
                    alphaFiltercontact ? [alphaFiltercontact] : ["All"]
                  }
                  onClick={({ key }) =>
                    setAlphaFiltercontact(key === "All" ? "" : key)
                  }
                  style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                >
                  <Menu.Item key="All" className="text-center">
                    All
                  </Menu.Item>
                  {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                    <Menu.Item key={letter} className="text-center">
                      {letter}
                    </Menu.Item>
                  ))}
                </Menu>
              }
            >
              <Button
                size="small"
                type="text"
                onClick={(e) => e.stopPropagation()}
                style={{
                  fontSize: 12,
                  height: 17,
                  padding: "0 8px",
                  border: "1px solid #d9d9d9",
                  background: "#fafafa",
                }}
              >
                {alphaFiltercontact ? alphaFiltercontact.toUpperCase() : "ALL"}
                <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
              </Button>
            </Dropdown>
          </div>
        ),
        dataIndex: "contact.contact_person_name",
        render: (text: any, record: any) =>
          <TextCopy2
            text={text || "N/A"}
            searchQuery={searchTerm}
            showPersonIcon={true}
            showIcon={false}
          />
      },
      product: {
        title: renderFilterDropdown({
          label: "Product",
          filterState: filterProducts,
          setFilterState: setFilterProducts,
          items: Array.from(
            new Set(
              dealsData.map((d) => d.product?.product_name).filter(Boolean)
            )
          )
            .sort()
            .map((name) => ({
              key: name,
              label: name,
              icon: <></>,
            })),
          counts: productCounts,
        }),
        dataIndex: "product.product_name",
        render: (text: any, record: any) =>
          highlightMatch(record.product?.product_name || "N/A", searchTerm),
      },
      expected_close_date: {
        title: "Expected Close Date",
        dataIndex: "expected_closing_date",
        key: "expected_closing_date",
        render: (text: any) =>
          <TextCopy2
            text={text || "N/A"}
            searchQuery={searchTerm}
            showDateIcon={true}
            showIcon={false}
          />
      },
      follow_up_date: {
        title: "Follow Up Date",
        dataIndex: "follow_up_date",
        key: "follow_up_date",
        render: (text: any) =>
          <TextCopy2
            text={text || "N/A"}
            searchQuery={searchTerm}
            showDateIcon={true}
            showIcon={false}
          />
      },
      due_date: {
        title: "Due Date",
        dataIndex: "due_date",
        key: "due_date",
        render: (text: any) =>
          <TextCopy2
            text={text || "N/A"}
            searchQuery={searchTerm}
            showDateIcon={true}
            showIcon={false}
          />
      },
      deal_source: {
        title: renderFilterDropdown({
          label: "Deal Source",
          filterState: filterDealSources,
          setFilterState: setFilterDealSources,
          items: dealSources
            .map((s) => s.deal_source_nema)
            .filter(Boolean)
            .filter((v, i, a) => a.indexOf(v) === i)
            .sort()
            .map((name) => ({
              key: name,
              label: name,
              icon: <></>,
            })),
          counts: dealSourceCounts,
        }),
        dataIndex: "dealsource.deal_source_nema",
        key: "deal_source",
        render: (text: any, record: any) =>
          highlightMatch(
            record.dealsource?.deal_source_nema || "N/A",
            searchTerm
          ),
      },
      created_at: {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        render: (text: string) =>
          text ? (
            <div>
              <div>{new Date(text).toLocaleDateString()}</div>
              <div style={{ fontSize: "12px", color: "#888" }}>
                {new Date(text).toLocaleTimeString()}
              </div>
            </div>
          ) : (
            "N/A"
          ),
      },
      updated_at: {
        title: "Updated At",
        dataIndex: "updated_at",
        key: "updated_at",
        render: (text: string) =>
          text ? (
            <div>
              <div>{new Date(text).toLocaleDateString()}</div>
              <div style={{ fontSize: "12px", color: "#888" }}>
                {new Date(text).toLocaleTimeString()}
              </div>
            </div>
          ) : (
            "N/A"
          ),
      },
      status: {
        title: renderFilterDropdown({
          label: "Status",
          filterState: filterStatuses,
          setFilterState: setFilterStatuses,
          items: [
            {
              key: "open",
              label: "Open",
              icon: <i className="bi bi-hourglass-split me-2 text-purple" />,
            },
            {
              key: "won",
              label: "Won",
              icon: <i className="bi bi-check-circle me-2 text-success" />,
            },
            {
              key: "lost",
              label: "Lost",
              icon: <i className="bi bi-x-circle me-2 text-danger" />,
            },
            {
              key: "Closed",
              label: "Closed",
              icon: <i className="bi bi-lock-fill me-2 text-dark" />,
            }, // ← key = "Closed"
          ],
          counts: dealStatusCounts,
        }),
        dataIndex: "status",
        render: (text: any) => {
          const status = text || "Not Updated";
          const statusMap: Record<string, { icon: string; className: string }> =
          {
            won: { icon: "bi bi-check-circle", className: "bg-success" },
            lost: { icon: "bi bi-x-circle", className: "bg-danger" },
            open: { icon: "bi bi-hourglass-split", className: "bg-purple" },
            Closed: { icon: "bi bi-lock-fill", className: "bg-secondary" }, // ← match exact
          };

          const statusData = statusMap[status] || {
            icon: "bi bi-question-circle",
            className: "bg-dark",
          };
          return (
            <AnimatedBadge
              status={status}
              className={statusData.className}
              icon={statusData.icon}
            />
          );
        },
      },
      priority: {
        title: renderFilterDropdown({
          label: "Priority",
          filterState: filterPriorities,
          setFilterState: setFilterPriorities,
          items: [
            {
              key: "high",
              label: "High",
              icon: (
                <i className="bi bi-arrow-up-circle-fill me-2 text-danger" />
              ),
            },
            {
              key: "medium",
              label: "Medium",
              icon: <i className="bi bi-dash-circle-fill me-2 text-warning" />,
            },
            {
              key: "low",
              label: "Low",
              icon: (
                <i className="bi bi-arrow-down-circle-fill me-2 text-success" />
              ),
            },
          ],
          counts: priorityCounts,
        }),
        dataIndex: "deal_priority",
        render: (text: any) => {
          const priority = text?.toLowerCase();
          const badgeClass =
            priority === "high"
              ? "bg-danger"
              : priority === "medium"
                ? "bg-warning"
                : priority === "low"
                  ? "bg-success"
                  : "badge-secondary";
          return (
            <AnimatedBadge status={text || "N/A"} className={badgeClass} />
          );
        },
      },
      description: {
        title: "Description",
        dataIndex: "Description",
        ellipsis: true,
        render: (text: any) => {
          const value = text || "N/A";

          return (
            <span
              style={{
                display: "inline-block",
                maxWidth: 180,          // 👈 adjust as needed
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {highlightMatch(value, searchTerm)}
            </span>
          );
        },
      },


      action: {
        title: "Actions",
        key: "action",
        fixed: "right",
        render: (_: any, record: Deal) => {
          const menu = (
            <Menu
              onClick={(e) => e.domEvent.stopPropagation()}
              style={{
                minWidth: 220,
                borderRadius: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <Menu.Item
                key="view-details"
                onClick={() => {
                  setSelectedDealForView(record);
                  setShowViewDetailsModal(true);
                }}
                className="d-flex align-items-center"
              >
                <i className="ti ti-eye text-primary me-2 fs-15" />
                <span>View Details</span>
              </Menu.Item>

              <Menu.Item
                key="edit"
                onClick={() => handleEditClick(record.deal_id)}
                className="d-flex align-items-center"
              >
                <i className="ti ti-edit text-primary me-2 fs-15" />
                <span>Edit Deal</span>
              </Menu.Item>
              <Menu.Item
                key="delete"
                data-bs-toggle="modal"
                data-bs-target="#delete_deal"
                onClick={() => setSelectedDealId(record.deal_id)}
                className="d-flex align-items-center text-danger"
              >
                <i className="ti ti-trash text-danger me-2 fs-15" />
                <span>Delete Deal</span>
              </Menu.Item>
            </Menu>
          );

          return (
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              placement="bottomRight"
              overlayClassName="table-actions-dropdown"
              onOpenChange={(open) => {
                if (open) {
                  // Prevent row click when dropdown opens
                  setTimeout(() => document.body.click(), 0);
                }
              }}
            >
              <Button
                size="small"
                type="default"
                className="table-action-btn"
                onClick={(e) => e.stopPropagation()}
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Button>
            </Dropdown>
          );
        },
      },
    };


    const cols = [
      allColumnsMap.index,
    ];

    columnKeys.forEach((key) => {
      if (visibleColumns[key] && allColumnsMap[key]) {
        cols.push(allColumnsMap[key]);
      }
    });


    // Separate sticky and non-sticky columns
    const stickyLeft: any[] = [];
    const stickyRight: any[] = [];
    const nonSticky: any[] = [];

    cols.forEach((col) => {
      if (col?.fixed === "left") {
        stickyLeft.push(col);
      } else if (col?.fixed === "right") {
        stickyRight.push(col);
      } else {
        nonSticky.push(col);
      }
    });

    // Sort non-sticky columns by columnKeys order


    // Combine: sticky left, sorted non-sticky, sticky right
    return [...stickyLeft, ...nonSticky, ...stickyRight];
  }, [
    columnKeys,
    visibleColumns,
    searchTerm,
    currentPage,
    pageSize,
    route.dealsDetails,
    handleEditClick,
    alphaFilter,
    alphaFilterleadowner,
    alphaFilterdealsource,
    alphaFilterproduct,
    alphaFiltercontact,
    filterStatuses,
    filterPriorities,
    filterProducts,
    filterDealSources,
    Array,
    dealSources,
    filterOwners,
    columnKeys,
  ]);

  const handleRowOrderChange = (newOrdered: Deal[]) => {
    setOrderedData(newOrdered);
    // OPTIONAL: persist to backend
    // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
  };

  const status = useMemo(
    () => [
      { value: "choose", label: "Choose" },
      { value: "open", label: "Open" },
      { value: "lost", label: "Lost" },
      { value: "won", label: "Won" },
      { value: "Closed", label: "Closed" },
    ],
    []
  );

  const currencys = useMemo(
    () => [
      { value: "Select", label: "Select" },
      { value: "$", label: "$" },
      { value: "€", label: "€" },
    ],
    []
  );

  const duration = useMemo(
    () => [
      { value: "Choose", label: "Choose" },
      { value: "Days", label: "Days" },
      { value: "Month", label: "Month" },
    ],
    []
  );

  const priorityList1 = useMemo(
    () => [
      { value: "Select", label: "Select" },
      { value: "high", label: "High" },
      { value: "low", label: "Low" },
      { value: "medium", label: "Medium" },
    ],
    []
  );

  const handleExportAllDealsPDF = useCallback(async () => {
    if (dealsData.length === 0) {
      toast.warning("No Deals available to export pdf.");
      return;
    }
    try {
      const response = await exportDealsPDF();
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `All_Deals.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Deals exported as PDF successfully");
    } catch (err) {
      console.error("Failed to export all deals as PDF");
    }
  }, [dealsData]);

  const handleExportAllDealsExcel = useCallback(async () => {
    if (dealsData.length === 0) {
      toast.warning("No Deals available to export excel.");
      return;
    }
    try {
      const response = await exportDealsExcel();
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `All_Deals.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Deals exported as Excel successfully");
    } catch (err) {
      console.error("Failed to export all deals as Excel");
    }
  }, [dealsData]);

  const handleExportSelectedDealsPDF = useCallback(
    async (dealIds: string[]) => {
      if (dealIds.length === 0) {
        toast.warning("Please select at least one deal to export pdf.");
        return;
      }
      try {
        const response = await exportSelectedDealsPDF(dealIds);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Selected_Deals.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("Selected deals exported as PDF successfully");
      } catch (err) {
        console.error("Failed to export selected deals as PDF");
      }
    },
    []
  );

  const handleExportSelectedDealsExcel = useCallback(
    async (dealIds: string[]) => {
      if (dealIds.length === 0) {
        toast.warning("Please select at least one deal to export excel.");
        return;
      }
      try {
        const response = await exportSelectedDealsExcel(dealIds);
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Selected_Deals.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("Selected deals exported as Excel successfully");
      } catch (err) {
        console.error("Failed to export selected deals as Excel");
      }
    },
    []
  );

  // State for export modal
  const [showExportModal, setShowExportModal] = useState(false);

  useEffect(() => {
    if (showExportModal) {
      setTimeout(() => {
        const modalElement = document.getElementById("custom_export_modal");
        if (modalElement) {
          setupDraggable(modalElement);
        }
      }, 100);
    }
  }, [showExportModal]);

  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [allColumnsSelected, setAllColumnsSelected] = useState(false);

  const exportColumns = [
    { key: "company_name", label: "Deal Name" },
    { key: "lead_owner_name", label: "Owner" },
    { key: "deal_value", label: "Deal Value" },
    { key: "currency", label: "Currency" },
    { key: "contact_person_name", label: "Contact person name" },
    { key: "product_name", label: "Product" },
    //{ key: "expected_closing_date", label: "Expected Close Date" },
    //{ key: "follow_up_date", label: "Follow Up Date" },
    //{ key: "due_date", label: "Due Date" },
    { key: "deal_source_name", label: "Deal Source" },
    { key: "deal_status", label: "Status" },
    { key: "created_at", label: "Created At" },
    { key: "updated_at", label: "Updated At" },
    { key: "deal_priority", label: "Priority" },
    { key: "deal_description", label: "Description" },
  ];

  const handleExportSubmit = async (format: "excel" | "pdf") => {
    if (selectedDeals.length === 0) {
      toast.warning("Please select at least one deal to export.");
      return;
    }

    if (selectedColumns.length === 0) {
      toast.warning("Please select at least one column to export.");
      return;
    }

    try {
      // Call your API function
      const result = await exportDeals(
        format, // 'pdf' or 'excel'
        selectedColumns, // e.g. ['deal_name', 'owner', 'deal_value']
        selectedDeals // array of selected deal_ids
      );

      // If the API returns a download URL (common pattern), trigger download
      if (result && typeof result === "string" && result.startsWith("http")) {
        window.open(result, "_blank"); // Open URL in new tab or trigger download
      }

      toast.success(`Deals exported successfully as ${format.toUpperCase()}`);
      setShowExportModal(false);
      setSelectedColumns([]); // Reset columns
      setAllColumnsSelected(false); // Reset "Select All"
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export deals. Please try again.");
    }
  };
  const handleSortChange = useCallback(
    (key: string, order: "Ascending" | "Descending") => {
      setSortKey(key);
      setSortOrder(order);
    },
    []
  );

  const handleStatusTabChange = useCallback((key: string | null) => {
    setActiveDealStatusTab((prev) => (prev === key ? null : key));
  }, []);

  const handleDateRangeChange = useCallback(
    (start: moment.Moment, end: moment.Moment, label?: string) => {
      setDateRange({
        startDate: start.toDate(),
        endDate: end.toDate(),
      });
      if (label) setActiveRangeLabel(label);
    },
    []
  );

  const handleFilterChange = useCallback(
    (
      value: string,
      list: string[],
      setList: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      if (list.includes(value)) {
        setList(list.filter((item) => item !== value));
      } else {
        setList([...list, value]);
      }
    },
    []
  );

  const handleAccordionToggle = useCallback((sectionId: string) => {
    setOpenAccordion((prev) => (prev === sectionId ? null : sectionId));
  }, []);

  return (
    <>
      <PageLoadProgressBar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header mb-0">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      <i className="ti ti-medal text-primary me-2" />
                      Deals
                      <span className="count-title">
                        <CountUp
                          end={dealsData.length}
                          duration={3.0}
                          separator=","
                        />
                      </span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* Breadcrumb */}
              <nav
                aria-label="breadcrumb"
                className="page-header-breadcrumb mb-3"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link
                      to={
                        userRole === "admin"
                          ? route.dealsDashboard
                          : route.leadsDashboard
                      }
                      style={{
                        color: "#9595b5",
                        textDecoration: "none",
                        transition: "color 0.2s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = "#E41F07")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "#9595b5")
                      }
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Deals
                  </li>
                </ol>
              </nav>
              {/* /Breadcrumb */}
              <div className="card">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-lg-4 col-md-6 col-sm-12">
                      <div className="icon-form position-relative mb-3 mb-sm-0 ms-3">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Deals ..."
                          autoFocus
                          autoComplete="off"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{
                            paddingRight: searchTerm ? "60px" : "15px",
                          }}
                        />

                        {/* Clear Button - Fixed & Visible */}
                        {searchTerm && (
                          <button
                            type="button"
                            className="position-absolute end-0 top-50 translate-middle-y me-3 text-muted"
                            style={{
                              zIndex: 10,
                              background: "none",
                              border: "none",
                              width: "30px",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => setSearchTerm("")}
                            aria-label="Clear search"
                          >
                            <i className="ti ti-x fs-16" />
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <SequentialHighlight>
                          {userRole === "admin" && (
                            <Link
                              to={route.dealsInsights}
                              className="btn btn-outline-warning me-2 mb-0"
                            >
                              <i className="ti ti-graph me-2" />
                              Deals Insights
                            </Link>
                          )}
                        </SequentialHighlight>
                        <div className="dropdown me-3">
                          <button
                            type="button"
                            className={`btn btn-outline-secondary d-flex align-items-center gap-2 dropdown-toggle ${selectedDeals.length > 0
                              ? "border-primary text-primary"
                              : ""
                              }`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={loading}
                          >
                            <i className="ti ti-package-export fs-16" />
                            <span className="d-none d-sm-inline">Export</span>
                            {selectedDeals.length > 0 && (
                              <span className="badge bg-primary rounded-pill ms-2">
                                {selectedDeals.length}
                              </span>
                            )}
                          </button>

                          <ul
                            className="dropdown-menu dropdown-menu-end shadow-lg border-0 py-3 px-2"
                            style={{ minWidth: "260px" }}
                          >
                            {/* Header */}
                            <li>
                              <div className="px-3 mb-2">
                                <small className="text-uppercase text-muted fw-bold">
                                  Export Options
                                </small>
                              </div>
                            </li>

                            {/* Export All */}
                            <li>
                              <hr className="dropdown-divider my-1" />
                            </li>
                            <li>
                              <div className="px-3 py-1">
                                <small className="text-muted">
                                  All Records ({dealsData.length})
                                </small>
                              </div>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={handleExportAllDealsPDF}
                              >
                                <div className="avatar avatar-sm bg-danger-light rounded">
                                  <i className="ti ti-file-type-pdf text-danger fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">Export as PDF</div>
                                  <small className="text-muted">
                                    Portable Document Format
                                  </small>
                                </div>
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={handleExportAllDealsExcel}
                              >
                                <div className="avatar avatar-sm bg-success-light rounded">
                                  <i className="ti ti-file-spreadsheet text-success fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">
                                    Export as Excel
                                  </div>
                                  <small className="text-muted">
                                    Spreadsheet (.xlsx)
                                  </small>
                                </div>
                              </button>
                            </li>

                            {/* Export Selected */}
                            {selectedDeals.length > 0 && (
                              <>
                                <li>
                                  <hr className="dropdown-divider my-2" />
                                </li>
                                <li>
                                  <div className="px-3 py-1">
                                    <small className="text-muted">
                                      Selected Only ({selectedDeals.length})
                                    </small>
                                  </div>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                    onClick={() =>
                                      handleExportSelectedDealsPDF(
                                        selectedDeals
                                      )
                                    }
                                  >
                                    <div className="avatar avatar-sm bg-danger-light rounded">
                                      <i className="ti ti-file-type-pdf text-danger fs-14" />
                                    </div>
                                    <div className="text-start">
                                      <div className="fw-medium">
                                        Export Selected as PDF
                                      </div>
                                    </div>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                    onClick={() =>
                                      handleExportSelectedDealsExcel(
                                        selectedDeals
                                      )
                                    }
                                  >
                                    <div className="avatar avatar-sm bg-success-light rounded">
                                      <i className="ti ti-file-spreadsheet text-success fs-14" />
                                    </div>
                                    <div className="text-start">
                                      <div className="fw-medium">
                                        Export Selected as Excel
                                      </div>
                                    </div>
                                  </button>
                                </li>
                              </>
                            )}

                            {/* Customized Export */}
                            <li>
                              <hr className="dropdown-divider my-2" />
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center gap-3 py-2 rounded-3"
                                onClick={() => {
                                  if (selectedDeals.length === 0) {
                                    toast.warning(
                                      "Please select at least one deal to export."
                                    );
                                    return;
                                  }
                                  setShowExportModal(true);
                                }}
                              >
                                <div className="avatar avatar-sm bg-warning-light rounded">
                                  <i className="ti ti-file-settings text-warning fs-14" />
                                </div>
                                <div className="text-start">
                                  <div className="fw-medium">
                                    Customized Export
                                  </div>
                                  <small className="text-muted">
                                    Select columns & format
                                  </small>
                                </div>
                              </button>
                            </li>

                            {/* No selection hint */}
                            {selectedDeals.length === 0 && (
                              <li>
                                <div className="text-center py-4 px-3">
                                  <i className="ti ti-checkbox fs-32 text-muted d-block mb-2" />
                                  <small className="text-muted">
                                    Select rows to export specific records
                                  </small>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort
                        </Link>
                        <div className="dropdown-menu dropdown-menu-start">
                          <ul>
                            {[
                              {
                                label: "Ascending",
                                key: "contact.company_name",
                                order: "Ascending",
                              },
                              {
                                label: "Descending",
                                key: "contact.company_name",
                                order: "Descending",
                              },
                              // {
                              //   label: "Recently Viewed",
                              //   key: "updated_at",
                              //   order: "Recently Viewed",
                              // },
                              {
                                label: "Recently Added",
                                key: "created_at",
                                order: "Recently Added ",
                              },
                            ].map(({ label, key, order }) => {
                              const isActive =
                                sortKey === key && sortOrder === order;
                              return (
                                <li key={label}>
                                  <Link
                                    to="#"
                                    className={`dropdown-item d-flex justify-content-between align-items-center ${isActive ? "fw-bold text-primary" : ""
                                      }`}
                                    onClick={() =>
                                      handleSortChange(
                                        key,
                                        order as "Ascending" | "Descending"
                                      )
                                    }
                                  >
                                    <span>
                                      <i className="ti ti-circle-chevron-right me-1" />
                                      {label}
                                    </span>
                                    {isActive && <i className="ti ti-check" />}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-filter-check me-2" />
                          Deal Status
                        </Link>
                        <div className="dropdown-menu dropdown-menu-start">
                          <ul>
                            <li>
                              <Link
                                to="#"
                                className={`dropdown-item d-flex justify-content-between align-items-center ${activeDealStatusTab === null
                                  ? "fw-bold text-primary"
                                  : ""
                                  }`}
                                onClick={() => handleStatusTabChange(null)}
                              >
                                <span>
                                  <i className="ti ti-circle-dot me-1" />
                                  All
                                </span>
                                <span className="badge bg-light text-dark border">
                                  {Object.values(dealStatusCounts).reduce(
                                    (acc, count) => acc + count,
                                    0
                                  )}
                                </span>
                                {activeDealStatusTab === null && (
                                  <i className="ti ti-check ms-2 text-success" />
                                )}
                              </Link>
                            </li>
                            {dealStatusTabs.map(({ key, label }) => {
                              const isActive = activeDealStatusTab === key;
                              return (
                                <li key={key}>
                                  <Link
                                    to="#"
                                    className={`status-dropdown-item dropdown-item d-flex justify-content-between align-items-center ${isActive ? "active" : ""
                                      }`}
                                    onClick={() => handleStatusTabChange(key)}
                                  >
                                    <span>
                                      <i className="ti ti-circle-chevron-right me-1" />
                                      {label}
                                    </span>
                                    <span className="badge bg-light text-dark border">
                                      {dealStatusCounts[key] || 0}
                                    </span>
                                    {isActive && (
                                      <i className="ti ti-check ms-2 text-success" />
                                    )}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar" />
                        </span>
                        <DateRangePicker
                          initialSettings={initialSettings}
                          onCallback={handleDateRangeChange}
                        >
                          <input
                            className="form-control date-range bookingrange"
                            type="text"
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      {selectedDeals.length > 0 && (
                        <button
                          className="btn btn-outline-danger me-2 mb-0 d-flex align-items-center"
                          onClick={() => setShowBulkDeleteModal(true)}
                        >
                          <i className="ti ti-trash me-2" />
                          Bulk Delete ({selectedDeals.length})
                        </button>
                      )}

                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div className="dropdown-menu dropdown-menu-md-end dropdown-md p-3">
                          <h4 className="mb-2 fw-semibold">
                            Manage DataTable Columns
                          </h4>
                          <p className="mb-3">
                            Toggle column visibility to customize your table
                            view.
                          </p>
                          <div className="border-top pt-3">
                            <ColumnManagement
                              columnKeys={columnKeys}
                              visibleColumns={visibleColumns}
                              onColumnOrderChange={setColumnKeys}
                              onColumnToggle={(key) => {
                                setVisibleColumns((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }));
                              }}
                              fixedKeys={["index", "action", "deal_name"]}
                              labels={columnLabels}
                            />
                          </div>

                        </div>
                      </div>
                      <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle dropdown-active-toggle common-filter-btn"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" /> Filter
                          {(filterLeadNames.length > 0 ||
                            filterContacts.length > 0 ||
                            filterOwners.length > 0 ||
                            filterStatuses.length > 0 ||
                            filterPriorities.length > 0 ||
                            filterDealSources.length > 0 ||
                            filterProducts.length > 0) && (
                              <span className="badge bg-primary rounded-pill ms-2 filter-btn-badge">
                                {filterLeadNames.length +
                                  filterContacts.length +
                                  filterOwners.length +
                                  filterStatuses.length +
                                  filterPriorities.length +
                                  filterDealSources.length +
                                  filterProducts.length}
                              </span>
                            )}
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" /> Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              {/* Lead Name */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "leadName"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("leadName")
                                    }
                                  >
                                    Lead Name
                                  </Link>
                                  {filterLeadNames.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterLeadNames.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "leadName" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Lead Name"
                                          value={filterLeadNamesSearch}
                                          onChange={(e) =>
                                            setFilterLeadNamesSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <ul className="list-unstyled">
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.contact?.company_name
                                              )
                                              .filter(Boolean)
                                          )
                                        )
                                          .filter((name) =>
                                            (name || "")
                                              .toLowerCase()
                                              .includes(
                                                filterLeadNamesSearch.toLowerCase()
                                              )
                                          )
                                          .map((name) => (
                                            <li key={name}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterLeadNames.includes(
                                                      name || ""
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        name || "",
                                                        filterLeadNames,
                                                        setFilterLeadNames
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {name}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.contact?.company_name
                                              )
                                              .filter(Boolean)
                                          )
                                        ).filter((name) =>
                                          (name || "")
                                            .toLowerCase()
                                            .includes(
                                              filterLeadNamesSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Contact */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "contact"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("contact")
                                    }
                                  >
                                    Contact
                                  </Link>
                                  {filterContacts.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterContacts.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "contact" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Contact"
                                          value={filterContactsSearch}
                                          onChange={(e) =>
                                            setFilterContactsSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <ul className="list-unstyled">
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.contact
                                                    ?.contact_person_name
                                              )
                                              .filter(Boolean)
                                          )
                                        )
                                          .filter((name) =>
                                            (name || "")
                                              .toLowerCase()
                                              .includes(
                                                filterContactsSearch.toLowerCase()
                                              )
                                          )
                                          .map((name) => (
                                            <li key={name}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterContacts.includes(
                                                      name || ""
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        name || "",
                                                        filterContacts,
                                                        setFilterContacts
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {name}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.contact
                                                    ?.contact_person_name
                                              )
                                              .filter(Boolean)
                                          )
                                        ).filter((name) =>
                                          (name || "")
                                            .toLowerCase()
                                            .includes(
                                              filterContactsSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Owner */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "owner"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("owner")
                                    }
                                  >
                                    Owner
                                  </Link>
                                  {filterOwners.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterOwners.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "owner" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Owner"
                                          value={filterOwnersSearch}
                                          onChange={(e) =>
                                            setFilterOwnersSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <ul className="list-unstyled">
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.leads?.users?.name
                                              )
                                              .filter(Boolean)
                                          )
                                        )
                                          .filter((owner) =>
                                            (owner || "")
                                              .toLowerCase()
                                              .includes(
                                                filterOwnersSearch.toLowerCase()
                                              )
                                          )
                                          .map((owner) => (
                                            <li key={owner}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterOwners.includes(
                                                      owner || ""
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        owner || "",
                                                        filterOwners,
                                                        setFilterOwners
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {owner}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.leads?.users?.name
                                              )
                                              .filter(Boolean)
                                          )
                                        ).filter((owner) =>
                                          (owner || "")
                                            .toLowerCase()
                                            .includes(
                                              filterOwnersSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Status */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "status"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("status")
                                    }
                                  >
                                    Status
                                  </Link>
                                  {filterStatuses.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterStatuses.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "status" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Status"
                                          value={filterStatusesSearch}
                                          onChange={(e) =>
                                            setFilterStatusesSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <ul className="list-unstyled">
                                        {["open", "won", "lost", "Closed"]
                                          .filter((s) =>
                                            s
                                              .toLowerCase()
                                              .includes(
                                                filterStatusesSearch.toLowerCase()
                                              )
                                          )
                                          .map((status) => (
                                            <li key={status}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterStatuses.includes(
                                                      status
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        status,
                                                        filterStatuses,
                                                        setFilterStatuses
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {status
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    status.slice(1)}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {[
                                          "open",
                                          "won",
                                          "lost",
                                          "Closed",
                                        ].filter((s) =>
                                          s
                                            .toLowerCase()
                                            .includes(
                                              filterStatusesSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Priority */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "priority"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("priority")
                                    }
                                  >
                                    Priority
                                  </Link>
                                  {filterPriorities.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterPriorities.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "priority" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Priority"
                                          value={filterPrioritiesSearch}
                                          onChange={(e) =>
                                            setFilterPrioritiesSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <ul className="list-unstyled">
                                        {["high", "medium", "low"]
                                          .filter((p) =>
                                            p
                                              .toLowerCase()
                                              .includes(
                                                filterPrioritiesSearch.toLowerCase()
                                              )
                                          )
                                          .map((priority) => (
                                            <li key={priority}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterPriorities.includes(
                                                      priority
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        priority,
                                                        filterPriorities,
                                                        setFilterPriorities
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {priority
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    priority.slice(1)}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {["high", "medium", "low"].filter((p) =>
                                          p
                                            .toLowerCase()
                                            .includes(
                                              filterPrioritiesSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Deal Source */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "dealSource"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("dealSource")
                                    }
                                  >
                                    Deal Source
                                  </Link>
                                  {filterDealSources.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterDealSources.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "dealSource" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Deal Source"
                                          value={filterDealSourcesSearch}
                                          onChange={(e) =>
                                            setFilterDealSourcesSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <ul className="list-unstyled">
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.dealsource
                                                    ?.deal_source_nema
                                              )
                                              .filter(Boolean)
                                          )
                                        )
                                          .filter((src) =>
                                            (src || "")
                                              .toLowerCase()
                                              .includes(
                                                filterDealSourcesSearch.toLowerCase()
                                              )
                                          )
                                          .map((src) => (
                                            <li key={src}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterDealSources.includes(
                                                      src || ""
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        src || "",
                                                        filterDealSources,
                                                        setFilterDealSources
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {src}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.dealsource
                                                    ?.deal_source_nema
                                              )
                                              .filter(Boolean)
                                          )
                                        ).filter((src) =>
                                          (src || "")
                                            .toLowerCase()
                                            .includes(
                                              filterDealSourcesSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />

                              {/* Product */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className={`filter-accordion-link ${
                                      openAccordion === "product"
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    onClick={() =>
                                      handleAccordionToggle("product")
                                    }
                                  >
                                    Product
                                  </Link>
                                  {filterProducts.length > 0 && (
                                    <span className="badge bg-primary rounded-pill small">
                                      {filterProducts.length}
                                    </span>
                                  )}
                                </div>
                                {openAccordion === "product" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Product"
                                          value={filterProductsSearch}
                                          onChange={(e) =>
                                            setFilterProductsSearch(
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <ul className="list-unstyled">
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.product?.product_name
                                              )
                                              .filter(Boolean)
                                          )
                                        )
                                          .filter((prod) =>
                                            (prod || "")
                                              .toLowerCase()
                                              .includes(
                                                filterProductsSearch.toLowerCase()
                                              )
                                          )
                                          .map((prod) => (
                                            <li key={prod}>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    checked={filterProducts.includes(
                                                      prod || ""
                                                    )}
                                                    onChange={() =>
                                                      handleFilterChange(
                                                        prod || "",
                                                        filterProducts,
                                                        setFilterProducts
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />{" "}
                                                  {prod}
                                                </label>
                                              </div>
                                            </li>
                                          ))}
                                        {Array.from(
                                          new Set(
                                            dealsData
                                              .map(
                                                (deal) =>
                                                  deal.product?.product_name
                                              )
                                              .filter(Boolean)
                                          )
                                        ).filter((prod) =>
                                          (prod || "")
                                            .toLowerCase()
                                            .includes(
                                              filterProductsSearch.toLowerCase()
                                            )
                                        ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="my-2" />
                            </div>

                            {/* Reset/Filter Buttons */}
                            <div className="filter-reset-btns">
                              <div className="row">
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-light w-100"
                                    onClick={resetFilters}
                                  >
                                    Reset
                                  </Link>
                                </div>
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-primary w-100 filter-apply-btn"
                                  >
                                    Filter
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="view-icons">
                        <Link to={route.deals} className="active">
                          <i className="ti ti-list-tree" />
                        </Link>
                        <Link to={route.dealsKanban}>
                          <i className="ti ti-grid-dots" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* Filter Status Alerts */}
                  {(filterLeadNames.length > 0 ||
                    filterContacts.length > 0 ||
                    filterProducts.length > 0 ||
                    filterStatuses.length > 0 ||
                    filterPriorities.length > 0 ||
                    filterOwners.length > 0 ||
                    filterDealSources.length > 0 ||
                    searchTerm ||
                    (dateRange.startDate && dateRange.endDate) ||
                    sortKey !== null ||
                    activeDealStatusTab) && (
                      <div className="active-filters d-flex flex-wrap gap-2 mb-3">
                        {searchTerm && (
                          <div className="alert alert-secondary py-2 mb-2">
                            Searching for: <strong>{searchTerm}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setSearchTerm("")}
                            ></i>
                          </div>
                        )}
                        {dateRange.startDate && dateRange.endDate && (
                          <div className="alert alert-info py-2 mb-2">
                            Showing deals created between:{" "}
                            <strong>
                              {moment(dateRange.startDate).format("MMM D, YYYY")}{" "}
                              - {moment(dateRange.endDate).format("MMM D, YYYY")}{" "}
                              ({activeRangeLabel})
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => {
                                setDateRange({ startDate: null, endDate: null });
                                setActiveRangeLabel("Overall");
                              }}
                            ></i>
                          </div>
                        )}
                        {sortKey && sortOrder && (
                          <div className="alert alert-secondary py-2 mb-2">
                            Showing deals sorted by: <strong>{sortOrder}</strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => {
                                setSortKey(null);
                                setSortOrder(null);
                              }}
                            />
                          </div>
                        )}

                        {activeDealStatusTab && (
                          <div className="alert alert-warning py-2 mb-2">
                            Showing deals with status:{" "}
                            <strong>
                              {activeDealStatusTab.charAt(0).toUpperCase() +
                                activeDealStatusTab.slice(1)}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setActiveDealStatusTab(null)}
                            ></i>
                          </div>
                        )}
                        {filterStatuses.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            Showing deals with statuses:{" "}
                            <strong>
                              {filterStatuses
                                .map(
                                  (s) => s.charAt(0).toUpperCase() + s.slice(1)
                                )
                                .join(", ")}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterStatuses([])}
                            ></i>
                          </div>
                        )}
                        {filterPriorities.length > 0 && (
                          <div className="alert alert-warning py-2 mb-2">
                            Showing deals with priorities:{" "}
                            <strong>
                              {filterPriorities
                                .map(
                                  (p) => p.charAt(0).toUpperCase() + p.slice(1)
                                )
                                .join(", ")}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterPriorities([])}
                            ></i>
                          </div>
                        )}
                        {filterOwners.length > 0 && (
                          <div className="alert alert-primary py-2 mb-2">
                            Showing deals with owners:{" "}
                            <strong>
                              {filterOwners.slice(0, 2).join(", ")}
                              {filterOwners.length > 2 &&
                                ` +${filterOwners.length - 2} more`}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterOwners([])}
                            ></i>
                          </div>
                        )}
                        {filterDealSources.length > 0 && (
                          <div className="alert alert-success py-2 mb-2">
                            Showing deals with deal sources:{" "}
                            <strong>
                              {filterDealSources.slice(0, 2).join(", ")}
                              {filterDealSources.length > 2 &&
                                ` +${filterDealSources.length - 2} more`}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterDealSources([])}
                            ></i>
                          </div>
                        )}
                        {filterLeadNames.length > 0 && (
                          <div className="alert alert-dark py-2 mb-2">
                            Showing deals with lead names:{" "}
                            <strong>
                              {filterLeadNames.slice(0, 2).join(", ")}
                              {filterLeadNames.length > 2 &&
                                ` +${filterLeadNames.length - 2} more`}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterLeadNames([])}
                            ></i>
                          </div>
                        )}
                        {filterContacts.length > 0 && (
                          <div className="alert alert-light py-2 mb-2">
                            Showing deals with contact persons:{" "}
                            <strong>
                              {filterContacts.slice(0, 2).join(", ")}
                              {filterContacts.length > 2 &&
                                ` +${filterContacts.length - 2} more`}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterContacts([])}
                            ></i>
                          </div>
                        )}
                        {filterProducts.length > 0 && (
                          <div className="alert alert-danger py-2 mb-2">
                            Showing deals with products:{" "}
                            <strong>
                              {filterProducts.slice(0, 2).join(", ")}
                              {filterProducts.length > 2 &&
                                ` +${filterProducts.length - 2} more`}
                            </strong>
                            <i
                              className="ti ti-x fs-12 cursor-pointer ms-2"
                              onClick={() => setFilterProducts([])}
                            ></i>
                          </div>
                        )}
                      </div>
                    )}
                  <div className="table-responsive custom-table">
                    <Table
                      columns={columns}
                      dataSource={processedDeals}
                      rowKey="deal_id"
                      loading={loading}
                      emptyText="No Deals found"
                      emptyIcon="ti ti-award-off"
                      recordLabel="Deals"
                      enableRowSelection={true}
                      rowSelection={{
                        selectedRowKeys: selectedDeals,
                        onChange: (selectedRowKeys) =>
                          setSelectedDeals(selectedRowKeys.map(String)),
                      }}
                      pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50", "75", "100"],
                        onChange: (page: number, size: number) => {
                          setCurrentPage(page);
                          setPageSize(size);
                        },
                      }}
                      scroll={{ x: "max-content" }}
                      draggable={true} // <-- ENABLE
                      enableColumnDrag={true}
                      onRowOrderChange={handleRowOrderChange} // <-- callback
                      onColumnOrderChange={(newCols: any[]) => {
                        const newKeys = newCols
                          .filter((c) => !c.fixed) // Only non-sticky columns
                          .map((c) => c.key);
                        setColumnKeys(newKeys);
                        // Don't auto-save, let user decide on navigation/refresh
                        // localStorage.setItem(
                        //   "dealsColumnKeys",
                        //   JSON.stringify(newKeys)
                        // );
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Deals</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Deal Name <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <label className="col-form-label">
                      Pipeline <span className="text-danger">*</span>
                    </label>
                    <Link
                      to=""
                      className="label-add"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvas_pipeline"
                    >
                      <i className="ti ti-square-rounded-plus"></i>
                      Add New
                    </Link>
                  </div>
                  <Select
                    className="select2"
                    options={salestypelist}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={status}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Deal Value<span className="text-danger"> *</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Deal Value"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Currency <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={currencys}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Period <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={duration}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Period Value <span className="text-danger">*</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Contact <span className="text-danger">*</span>
                  </label>
                  <SelectWithImage2 />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Project <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={project}
                    defaultValue={tagInputValues}
                    isMulti
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Due Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Expected Closing Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate1}
                      onChange={handleDateChange1}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Assignee <span className="text-danger">*</span>
                  </label>
                  <SelectWithImage2 />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Follow Up Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate2}
                      onChange={handleDateChange2}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Source <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={socialMedia}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Tags <span className="text-danger">*</span>
                  </label>
                  <TagsInput value={owner} onChange={setOwner} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Priority <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={priorityList1}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <DefaultEditor
                    className="summernote"
                    placeholder="Enter Deal Description"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setOpenModal(true)}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {showEditDeals && (
        <>
          <div
            className="offcanvas-backdrop fade show"
            onClick={() => setShowEditDeals(false)}
            style={{ zIndex: 1040 }}
          />
          <div
            className="offcanvas offcanvas-end offcanvas-large show d-block"
            style={{ visibility: "visible", zIndex: 1050 }}
          >
            <div className="offcanvas-header border-bottom">
              <h5 className="fw-semibold">Edit Deals</h5>
              <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={() => setShowEditDeals(false)}
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div
              className="offcanvas-body overflow-auto"
              style={{ maxHeight: "calc(100vh - 60px)" }}
            >
              <form>
                <h6 className="mt-3 mb-3 border-bottom pb-1">
                  <i className="ti ti-chart-bar me-2 text-primary" />
                  Deal Overview
                </h6>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="col-form-label">Deal Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData?.contact?.company_name || ""}
                      onChange={(e) =>
                        setEditData({
                          ...editData!,
                          contact: {
                            ...editData!.contact,
                            company_name: e.target.value,
                          },
                        })
                      }
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Deal Value <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      className={`form-control ${editErrors.deal_value ? "is-invalid" : ""
                        }`}
                      placeholder="Enter Deal Value"
                      value={editData?.deal_value || ""}
                      onChange={(e) => {
                        const { cleaned, formatted } = formatDealValue(
                          e.target.value
                        );

                        // Update local state with cleaned (unformatted) number
                        const updated = { ...editData!, deal_value: cleaned };

                        setEditData(updated);

                        // Live validation
                        setEditErrors(
                          validateDealEditForm({
                            deal_value: cleaned,
                            expected_closing_date:
                              updated.expected_closing_date,
                            follow_up_date: updated.follow_up_date,
                            due_date: updated.due_date,
                            deal_source_id:
                              updated.dealsource?.deal_source_id || "",
                            status: updated.status,
                            deal_priority: updated.deal_priority,
                            Description: updated.Description || "",
                          })
                        );
                      }}
                      maxLength={20} // safety guard
                      inputMode="numeric"
                    />

                    {editErrors.deal_value && (
                      <small className="text-danger">
                        {editErrors.deal_value}
                      </small>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">Currency</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData?.currency || ""}
                      onChange={(e) =>
                        setEditData({ ...editData!, currency: e.target.value })
                      }
                      readOnly
                    />
                  </div>
                </div>
                <h6 className="mt-4 mb-3 border-bottom pb-1">
                  <i className="ti ti-user me-2 text-primary" />
                  Contact & Product
                </h6>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">Contact</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData?.contact?.contact_person_name || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">Product</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editData?.product?.product_name || ""}
                      readOnly
                    />
                  </div>
                </div>
                <h6 className="mt-4 mb-3 border-bottom pb-1">
                  <i className="ti ti-calendar me-2 text-primary" />
                  Deal Dates
                </h6>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Expected Closing Date{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className={`form-control ${editErrors.expected_closing_date ? "is-invalid" : ""
                        }`}
                      value={
                        editData?.expected_closing_date?.split("T")[0] || ""
                      }
                      onChange={(e) => {
                        const updated = {
                          ...editData!,
                          expected_closing_date: e.target.value,
                        };
                        setEditData(updated);
                        setEditErrors(
                          validateDealEditForm({
                            deal_value: updated.deal_value,
                            expected_closing_date:
                              updated.expected_closing_date,
                            follow_up_date: updated.follow_up_date,
                            due_date: updated.due_date,
                            deal_source_id:
                              updated.dealsource?.deal_source_id || "",
                            status: updated.status,
                            deal_priority: updated.deal_priority,
                            Description: updated.Description,
                          })
                        );
                      }}
                    />
                    {editErrors.expected_closing_date && (
                      <small className="text-danger">
                        {editErrors.expected_closing_date}
                      </small>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Follow Up Date <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className={`form-control ${editErrors.follow_up_date ? "is-invalid" : ""
                        }`}
                      value={editData?.follow_up_date?.split("T")[0] || ""}
                      onChange={(e) => {
                        const updated = {
                          ...editData!,
                          follow_up_date: e.target.value,
                        };
                        setEditData(updated);
                        setEditErrors(
                          validateDealEditForm({
                            deal_value: updated.deal_value,
                            expected_closing_date:
                              updated.expected_closing_date,
                            follow_up_date: updated.follow_up_date,
                            due_date: updated.due_date,
                            deal_source_id:
                              updated.dealsource?.deal_source_id || "",
                            status: updated.status,
                            deal_priority: updated.deal_priority,
                            Description: updated.Description,
                          })
                        );
                      }}
                    />
                    {editErrors.follow_up_date && (
                      <small className="text-danger">
                        {editErrors.follow_up_date}
                      </small>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Due Date <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className={`form-control ${editErrors.due_date ? "is-invalid" : ""
                        }`}
                      value={editData?.due_date?.split("T")[0] || ""}
                      onChange={(e) => {
                        const updated = {
                          ...editData!,
                          due_date: e.target.value,
                        };
                        setEditData(updated);
                        setEditErrors(
                          validateDealEditForm({
                            deal_value: updated.deal_value,
                            expected_closing_date:
                              updated.expected_closing_date,
                            follow_up_date: updated.follow_up_date,
                            due_date: updated.due_date,
                            deal_source_id:
                              updated.dealsource?.deal_source_id || "",
                            status: updated.status,
                            deal_priority: updated.deal_priority,
                            Description: updated.Description,
                          })
                        );
                      }}
                    />
                    {editErrors.due_date && (
                      <small className="text-danger">
                        {editErrors.due_date}
                      </small>
                    )}
                  </div>
                </div>
                <h6 className="mt-4 mb-3 border-bottom pb-1">
                  <i className="ti ti-file-description me-2 text-primary" />
                  Additional Info
                </h6>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Deal Source <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ti ti-source-code" />{" "}
                        {/* Deal source icon */}
                      </span>
                      <div className="flex-grow-1">
                        <select
                          className={`form-select ${editErrors.deal_source_id ? "is-invalid" : ""
                            }`}
                          value={editData?.dealsource?.deal_source_id || ""}
                          onChange={(e) => {
                            const updated = {
                              ...editData!,
                              dealsource: {
                                ...editData!.dealsource,
                                deal_source_id: e.target.value,
                              },
                            };
                            setEditData(updated);
                            setEditErrors(
                              validateDealEditForm({
                                deal_value: updated.deal_value,
                                expected_closing_date:
                                  updated.expected_closing_date,
                                follow_up_date: updated.follow_up_date,
                                due_date: updated.due_date,
                                deal_source_id:
                                  updated.dealsource?.deal_source_id || "",
                                status: updated.status,
                                deal_priority: updated.deal_priority,
                                Description: updated.Description,
                              })
                            );
                          }}
                        >
                          <option value="">Select Source</option>
                          {dealSources.map((source) => (
                            <option
                              key={source.deal_source_id}
                              value={source.deal_source_id}
                            >
                              {source.deal_source_nema}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {editErrors.deal_source_id && (
                      <small className="text-danger">
                        {editErrors.deal_source_id}
                      </small>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Status <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ti ti-flag-check" /> {/* Status icon */}
                      </span>
                      <div className="flex-grow-1">
                        <select
                          className={`form-select ${editErrors.status ? "is-invalid" : ""
                            }`}
                          value={editData?.status || ""}
                          onChange={(e) => {
                            const updated = {
                              ...editData!,
                              status: e.target.value,
                            };
                            setEditData(updated);
                            setEditErrors(
                              validateDealEditForm({
                                deal_value: updated.deal_value,
                                expected_closing_date:
                                  updated.expected_closing_date,
                                follow_up_date: updated.follow_up_date,
                                due_date: updated.due_date,
                                deal_source_id:
                                  updated.dealsource?.deal_source_id || "",
                                status: updated.status,
                                deal_priority: updated.deal_priority,
                                Description: updated.Description,
                              })
                            );
                          }}
                        >
                          {status.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {editErrors.status && (
                      <small className="text-danger">{editErrors.status}</small>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Priority <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ti ti-graph" /> {/* Priority icon */}
                      </span>
                      <div className="flex-grow-1">
                        <select
                          className={`form-select ${editErrors.deal_priority ? "is-invalid" : ""
                            }`}
                          value={editData?.deal_priority || ""}
                          onChange={(e) => {
                            const updated = {
                              ...editData!,
                              deal_priority: e.target.value,
                            };
                            setEditData(updated);
                            setEditErrors(
                              validateDealEditForm({
                                deal_value: updated.deal_value,
                                expected_closing_date:
                                  updated.expected_closing_date,
                                follow_up_date: updated.follow_up_date,
                                due_date: updated.due_date,
                                deal_source_id:
                                  updated.dealsource?.deal_source_id || "",
                                status: updated.status,
                                deal_priority: updated.deal_priority,
                                Description: updated.Description,
                              })
                            );
                          }}
                        >
                          {priorityList1.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {editErrors.deal_priority && (
                      <small className="text-danger">
                        {editErrors.deal_priority}
                      </small>
                    )}
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="col-form-label">Description</label>
                    <textarea
                      className={`form-control ${editErrors.Description ? "is-invalid" : ""
                        }`}
                      placeholder="Enter Deal Description"
                      rows={4}
                      value={editData?.Description || ""}
                      onChange={(e) => {
                        const newDescription = e.target.value;
                        const updated = {
                          ...editData!,
                          Description: newDescription,
                        }; // Fixed
                        setEditData(updated);

                        // Run live validation with updated value
                        setEditErrors(
                          validateDealEditForm({
                            deal_value: updated.deal_value || "",
                            expected_closing_date:
                              updated.expected_closing_date || "",
                            follow_up_date: updated.follow_up_date || "",
                            due_date: updated.due_date || "",
                            deal_source_id:
                              updated.dealsource?.deal_source_id || "",
                            status: updated.status || "",
                            deal_priority: updated.deal_priority || "",
                            Description: newDescription,
                          })
                        );
                      }}
                    />
                    {editErrors.Description && (
                      <small className="text-danger">
                        {editErrors.Description}
                      </small>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={() => setShowEditDeals(false)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveEdit}
                    disabled={Object.keys(editErrors).length > 0}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
      <div
        className="modal fade effect-modal-show"
        id="delete_deal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="deleteDealLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title text-danger fw-bold"
                id="deleteDealLabel"
              >
                <i className="ti ti-alert-triangle me-2" />
                Confirm Deletion
              </h5>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body text-center">
              <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
                <i className="ti ti-trash fs-40 text-danger" />
              </div>

              {/* Show deal name if available */}
              {selectedDealId &&
                dealsData.find((d) => d.deal_id === selectedDealId) && (
                  <h4 className="fw-bold text-dark mb-3">
                    Delete "
                    {dealsData.find((d) => d.deal_id === selectedDealId)
                      ?.contact?.company_name ||
                      dealsData.find((d) => d.deal_id === selectedDealId)
                        ?.contact?.contact_person_name}
                    "?
                  </h4>
                )}

              {!selectedDealId && (
                <h4 className="fw-bold text-dark mb-3">Delete This Deal?</h4>
              )}

              <p className="text-muted fs-15 mb-4 px-4">
                This action <strong>cannot be undone</strong>. The deal will be
                <strong> permanently removed</strong> from your system.
              </p>

              <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                <i className="ti ti-info-circle me-2" />
                <strong>Warning:</strong> All associated data (notes, calls,
                emails) will also be deleted.
              </div>

              <div className="d-flex gap-3 justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-light px-5 py-2 fw-medium"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger px-5 py-2 fw-medium"
                  onClick={handleDeleteDeal}
                  data-bs-dismiss="modal"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-trash me-2" />
                      Yes, Delete It
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalDeleteEffect />
      <Modal
        show={showExportModal}
        onHide={() => setShowExportModal(false)}
        centered
        dialogAs={(props) => <div {...props} id="custom_export_modal" />}
        className="effect-modal-show"
      >
        <div
          id="custom_export_modal"
          className="modal fade show"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-primary fw-bold">
                  <i className="ti ti-file-export me-2" />
                  Customized Deal Export
                </h5>
                <button
                  className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                  aria-label="Close"
                  onClick={() => setShowExportModal(false)}
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <div className="modal-body p-4">
                {selectedDeals.length === 0 && (
                  <div className="alert alert-warning py-2 mb-3">
                    Please select at least one row from the table to export data.
                  </div>
                )}

                <p className="text-muted mb-4">
                  Select columns to include in the export (
                  <strong>{selectedDeals.length}</strong> deals selected):
                </p>

                <div className="row">
                  {/* Select All */}
                  <div className="col-md-12 mb-3">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="export-col-all"
                        checked={allColumnsSelected}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedColumns(exportColumns.map((c) => c.key));
                            setAllColumnsSelected(true);
                          } else {
                            setSelectedColumns([]);
                            setAllColumnsSelected(false);
                          }
                        }}
                      />
                      <label
                        className="form-check-label fw-semibold"
                        htmlFor="export-col-all"
                      >
                        Select All Columns
                      </label>
                    </div>
                    <hr />
                  </div>

                  {/* Individual Columns */}
                  {exportColumns.map((col) => (
                    <div className="col-md-6 mb-2" key={col.key}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`export-col-${col.key}`}
                          checked={selectedColumns.includes(col.key)}
                          onChange={() => {
                            setSelectedColumns((prev) =>
                              prev.includes(col.key)
                                ? prev.filter((c) => c !== col.key)
                                : [...prev, col.key]
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`export-col-${col.key}`}
                        >
                          {col.label}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-light px-4 py-2 fw-medium"
                  onClick={() => setShowExportModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => handleExportSubmit("pdf")}
                  disabled={
                    selectedDeals.length === 0 || selectedColumns.length === 0
                  }
                >
                  Export as PDF
                </button>

                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => handleExportSubmit("excel")}
                  disabled={
                    selectedDeals.length === 0 || selectedColumns.length === 0
                  }
                >
                  Export as Excel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        show={showBulkDeleteModal}
        onHide={() => {
          if (!isDeleting) setShowBulkDeleteModal(false);
        }}
        centered
        backdrop="static"
        className="effect-modal-show"
      >
        <div className="modal-header">
          <h5
            className="modal-title text-danger fw-bold"
            id="bulkDeleteDealsLabel"
          >
            <i className="ti ti-alert-triangle me-2" />
            Confirm Bulk Deletion
          </h5>
          <button
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            aria-label="Close"
            onClick={() => {
              if (!isDeleting) setShowBulkDeleteModal(false);
            }}
            disabled={isDeleting}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body text-center">
          <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
            <i className="ti ti-trash fs-40 text-danger" />
          </div>
          <h4 className="fw-bold text-dark mb-3">
            Delete {selectedDeals.length} Deal
            {selectedDeals.length > 1 ? "s" : ""}?
          </h4>
          <p className="text-muted fs-15 mb-4 px-4">
            This action <strong>cannot be undone</strong>. The selected deals
            will be
            <strong> permanently removed</strong> from your system.
          </p>
          <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
            <i className="ti ti-info-circle me-2" />
            <strong>Warning:</strong> This may affect related records, notes,
            call history, and email marketing data.
          </div>

          <div className="d-flex gap-3 justify-content-center mt-4">
            <button
              type="button"
              className="btn btn-light px-5 py-2 fw-medium"
              onClick={() => setShowBulkDeleteModal(false)}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger px-5 py-2 fw-medium"
              onClick={handleBulkDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Deleting...
                </>
              ) : (
                <>
                  <i className="ti ti-trash me-2" />
                  Yes, Delete Permanently
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-header border-0 m-0 justify-content-end">
          <button
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => setOpenModal(false)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-medal" />
            </div>
            <h3>Deal Created Successfully!!!</h3>
            <p>View the details of deal, created</p>
            <div className="col-lg-12 text-center modal-btn">
              <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                Cancel
              </Link>
              <Link to={route.dealsDetails} className="btn btn-primary">
                View Details
              </Link>
            </div>
          </div>
        </div>
      </Modal>

      {/* Deal Details Modal */}
      <DealDetailsModal
        deal={selectedDealForView}
        isOpen={showViewDetailsModal}
        onClose={() => {
          setShowViewDetailsModal(false);
          setSelectedDealForView(null);
        }}
      />

      {/* Save Column Order Modal */}
      <SaveModal />
      <ScrollToTop />
    </>
  );
};

export default Deals;
